const axios = require('axios');

export const routes = [
  {
    path: '/agreement',
    name: 'terms',
    component: () => import('./components/TermsAndAgreement.vue'),
  },
  {
    path: '/unsubscribe/:id',
    name: 'unsubscribe',
    component: () => import('./views/UnsubscribeLink.vue'),
    meta: {
      guest: true,
      sitemap: {
        ignoreRoute: true,
      },
    },
  },
  {
    path: '/',
    name: 'home',
    component: () => import('./components/Home.vue'),
    meta: { auth: true },
  },
  {
    path: '/job-listings',
    name: 'jobListings',
    component: () => import('./components/ScoutProfile/JobListings.vue'),
    meta: { auth: true },
  },
  {
    path: '/user-profile',
    name: 'userProfile',
    component: () => import('./components/UserProfile.vue'),
    meta: { auth: true },
  },
  {
    path: '/contact-list',
    name: 'contactList',
    component: () => import('./components/ContactList/ContactLists.vue'),
    meta: { 
      auth: true,
    },
  },
  {
    path: '/contact-list/:id',
    name: 'contactDetails',
    component: () => import('./components/ContactList/ContactDetails.vue'),
    meta: { 
      auth: true,
      sitemap: {
        ignoreRoute: true
      }
    },
  },
  {
    path: '/settings',
    name: 'changePassword',
    component: () => import('./components/ChangePassword.vue'),
    meta: { auth: true },
  },
  {
    path: '/verify-changed-email/:token/:id',
    name: 'verifyChangedEmail',
    component: () => import('./components/VerifyChangedEmail.vue'),
    meta: {
      guest: true,
      sitemap: {
        ignoreRoute: true,
      },
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('./components/Logout.vue'),
    meta: { auth: true },
  },
  // {
  //   path: '/registration/:slug',
  //   name: 'signup',
  //   component: () => import('./components/Agreement.vue'),
  //   meta: {
  //     sitemap: {
  //       slugs: async () => await getCompanies(),
  //     },
  //   },
  // },
  {
    path: '/registration/:slug',
    name: 'registration',
    component: () => import('./components/Registration.vue'),
    meta: {
      guest: true,
      sitemap: {
        slugs: async () => await getCompanies(),
      },
      // title: '登録フォーム | Bloomキャリア登録',
    },
  },
  {
    path: '/registration',
    name: 'bloomRegistration',
    component: () => import('./components/BloomRegistration.vue'),
    meta: {
      guest: true,
      sitemap: {
        ignoreRoute: false,
      },
      title: '登録フォーム | Bloomキャリア登録',
    },
  },
  {
    path: '/thank-you',
    name: 'thankyou',
    component: () => import('./components/ThankYou.vue'),
    meta: { guest: true, title: 'メール認証 | Bloomキャリア登録' },
  },
  {
    path: '/registration/:slug/preview',
    name: 'preview',
    component: () => import('./components/ProfilePreview.vue'),
    meta: {
      guest: true,
      sitemap: {
        ignoreRoute: true,
      },
      title: '入力内容の確認 | Bloomキャリア登録',
    },
  },
  {
    path: '/registration/preview',
    name: 'preview2',
    component: () => import('./components/BloomProfilePreview.vue'),
    meta: {
      guest: true,
      sitemap: {
        ignoreRoute: true,
      },
      title: '入力内容確認 | Bloomキャリア登録',
    },
  },
  {
    path: '/confirm/:token/:id',
    name: 'verifyEmail',
    component: () => import('./components/VerifyEmail.vue'),
    meta: { guest: true, sitemap: { ignoreRoute: true }, title: '登録フォーム | Bloomキャリア登録' },
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('./components/ForgotPassword.vue'),
    meta: { guest: true },
  },
  {
    path: '/reset/:token',
    name: 'resetPassword',
    component: () => import('./components/ResetPassword.vue'),
    meta: { guest: true, sitemap: { ignoreRoute: true } },
  },
  {
    path: '*',
    name: 'pageNotFound',
    component: () => import('./components/PageNotFound.vue'),
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('./components/Maintenance.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./components/LoginForm.vue'),
    meta: { guest: true },
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('./components/Terms.vue'),
  },
  {
    path: '/twofa-sent',
    name: 'twofaSent',
    component: () => import('./components/TwoFASent.vue'),
    meta: { guest: true },
  },
  {
    path: '/verify-2fa',
    name: 'verifyTwoFA',
    component: () => import('./components/VerifyTwoFA.vue'),
    meta: { guest: true },
  },
  {
    path: '/company-registration-complete',
    name: 'companyRegistrationComplete',
    component: () => import('./components/CompanyRegistrationComplete.vue'),
    meta: { auth: true },
  },
  {
    path: '/event/:id',
    name: 'EventDetail',
    component: () => import('./components/EventDetail.vue'),
    meta: { 
      auth: true,
      sitemap: {
        ignoreRoute: true
      }
    },
  },
];

async function getCompanies() {
  const response = await axios({
    method: 'get',
    url: `${process.env.VUE_APP_API_URL}/companies`,
  });
  return response.data;
}
